import { render, staticRenderFns } from "./ListpageDesigner.vue?vue&type=template&id=2c0c0443"
import script from "./ListpageDesigner.vue?vue&type=script&lang=js"
export * from "./ListpageDesigner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports